import { useEffect } from 'react'

const PRODUCT_NAME = 'bug.engineering'

export function useDocumentTitle(page?: string) {
  useEffect(() => {
    const previous = document.title
    document.title = page ? `${page} · ${PRODUCT_NAME}` : PRODUCT_NAME
    return () => {
      document.title = previous
    }
  }, [page])
}
